import { render, staticRenderFns } from "./UserTodo.vue?vue&type=template&id=b83da6ce&"
import script from "./UserTodo.vue?vue&type=script&lang=js&"
export * from "./UserTodo.vue?vue&type=script&lang=js&"
import style0 from "./UserTodo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports